/** @format */

import { type FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "../box/Box";
import { InputContainer, Label, Note, Wrapper } from "../inputs/input.styles";
import { Selector } from "./Dropdown.styles";
import type { DropdownProps } from "./Dropdown.types";

const Dropdown: FunctionComponent<DropdownProps> = ({
  name,
  placeholder,
  label,
  note,
  listItems,
  onChange,
  value,
  variant,
  required,
  error,
}) => {
  const { t } = useTranslation();
  const listItem = listItems.find((item) => item.value == value);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="flex flex-col gap-3">
      {label && (
        <Box>
          {label && (
            <Label error={error}>{`${label}${required ? "*" : ""}`}</Label>
          )}
        </Box>
      )}
      <InputContainer
        as={Selector}
        id={name}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        value={value || placeholder}
        variant={variant}
        onFocusCapture={() => setIsFocused((prevState) => !prevState)}
        onBlurCapture={() => setIsFocused((prevState) => !prevState)}
      >
        {placeholder && (
          <option
            value={placeholder}
            disabled
            // hidden
          >
            {placeholder}
          </option>
        )}
        {Object.values(listItems).map((item) => (
          <option key={`Option-${item.label}`} value={item.value}>
            {item.label}
          </option>
        ))}
      </InputContainer>
      {note && <Note error={error}>{note}</Note>}
    </div>
  );
};

export default Dropdown;
